//水源情况
export const waterConditionList = [
  {id:1,name:'较差'},
  {id:2,name:'一般'},
  {id:3,name:'良好'}
]
//放养信息确认列表
export const aquaticLineFishStockingInfoList = [
  {title: '放养次数（次）',field: 'stockingTimes'},
  {title: '合计放养品种数（个）',field: 'totalStockingVarietyNum'},
  {title: '合计放养数量（尾）',field: 'totalStockingNum'},
  {title: '合计放养重量（斤）',field: 'totalStockingWeight'},
  {title: '吃食鱼放养品种数（个）',field: 'eatFoodVarietyNum'},
  {title: '滤食鱼放养品种数（个）',field: 'filterFoodVarietyNum'},
  {title: '吃食鱼放养数量（尾）',field: 'eatFoodNum'},
  {title: '滤食鱼放养数量（尾）',field: 'filterFoodNum'},
  {title: '吃食鱼放养重量（斤）',field: 'eatFoodWeight'},
  {title: '滤食鱼放养重量（斤）',field: 'filterFoodWeight'}
]
//大样/收获信息确认列表
export const aquaticLineFishProofingHarvestInfoList = [
  {title: '打样/收获次数（次）',field: 'proofingHarvestTimes'},
  {title: '合计打样/收获品种数（个）',field: 'totalProofingHarvestVarietyNum'},
  {title: '合计打样/收获数量（尾）',field: 'totalProofingHarvestNum'},
  {title: '合计打样/收获重量（斤）',field: 'totalProofingHarvestWeight'},
  {title: '吃食鱼打样/收获品种数（个）',field: 'eatFoodProofingHarvestVarietyNum'},
  {title: '滤食鱼打样/收获品种数（个）',field: 'filterFoodProofingHarvestVarietyNum'},
  {title: '吃食鱼打样/收获数量（尾）',field: 'eatFoodProofingHarvestNum'},
  {title: '滤食鱼打样/收获数量（尾）',field: 'filterFoodProofingHarvestNum'},
  {title: '吃食鱼打样/收获重量（斤）',field: 'eatFoodProofingHarvestWeight'},
  {title: '滤食鱼打样/收获重量（斤）',field: 'filterFoodProofingHarvestWeight'}
]